import { PolicyPage } from '../components/PolicyRenderer'
import { cookieContent } from './cookieContent'
import PageMeta from '../components/PageMeta'

export default function CookiePolicy() {
    return <>
        <PageMeta
            title="Cookie Policy"
            description="Contract Finder Pro cookie policy. Information about the cookies we use and how to manage your cookie preferences."
            canonical="/cookies"
        />
        <PolicyPage content={cookieContent} />
    </>
}
